import { Stack, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { ClientPaginatedTable } from 'components/table';
import * as TableConfig from './tablesConfig';
import { selectTranslations } from 'state/reducers/translation.reducers';
import React, { useEffect, useState } from 'react';
import { editPaymentsPurpose } from 'services/global.service';
import { getCurrencies, getCountries } from 'state/reducers/global.reducer';

type IProps = {
	paymentsPurpose: Record<string, any>[];
};

export const PaymentsPurposeTable: React.FC<IProps> = ({ paymentsPurpose }: IProps) => {
	const t = useAppSelector(selectTranslations);
	const theme = useTheme();
	const dispatch = useAppDispatch();
	const [tableData, setTableData] = useState<Record<string, any>[]>([]);
	const countries = useAppSelector(getCountries);
	const currencies = useAppSelector(getCurrencies);

	useEffect(() => {
		setDefaultModifiedPaymentsPurpose();
	}, [paymentsPurpose]);

	const setDefaultModifiedPaymentsPurpose = () => {
		const modifiedPaymentsPurpose = paymentsPurpose?.map((paymentsPurpose: any) => {
			return { ...paymentsPurpose, editable: false };
		});
		setTableData(modifiedPaymentsPurpose || []);
	};

	const handleEditButtonClick = (countryId: number) => {
		const modifiedPaymentsPurpose = paymentsPurpose?.map((paymentsPurpose: any) => {
			return { ...paymentsPurpose, editable: countryId === paymentsPurpose.id ? true : false };
		});
		setTableData(modifiedPaymentsPurpose || []);
	};

	const savePaymentsPurpose = (newCountryData: any) => {
		const { id, active } = newCountryData;
		setDefaultModifiedPaymentsPurpose();
		dispatch(editPaymentsPurpose({ id, active: active ? 1 : 0 }, paymentsPurpose));
	};

	const cancelCountryChanges = () => {
		setDefaultModifiedPaymentsPurpose();
	};

	const updateModifiedPaymentsPurpose = (field: any, fieldValue: any, changedPaymentsPurpose: any) => {
		const modifiedPaymentsPurpose = paymentsPurpose?.map((paymentsPurpose: any) => {
			return {
				...paymentsPurpose,
				editable: changedPaymentsPurpose.id === paymentsPurpose.id ? true : false,
				name:
					changedPaymentsPurpose.id === paymentsPurpose.id
						? field === 'name'
							? fieldValue
							: changedPaymentsPurpose.name
						: paymentsPurpose.name,
				active:
					changedPaymentsPurpose.id === paymentsPurpose.id
						? field === 'active'
							? fieldValue
							: changedPaymentsPurpose.active
						: paymentsPurpose.active,
			};
		});
		setTableData(modifiedPaymentsPurpose || []);
	};

	return (
		<Stack spacing={2}>
			<Typography variant="subtitle" color={theme.palette.root.grey}>
				{paymentsPurpose?.length + ' ' + t('messages.results')}
			</Typography>
			{tableData && (
				<ClientPaginatedTable
					data={TableConfig.tableData(tableData)}
					columns={TableConfig.buildColumns(
						t,
						savePaymentsPurpose,
						cancelCountryChanges,
						updateModifiedPaymentsPurpose,
						countries,
						currencies
					)}
				/>
			)}
		</Stack>
	);
};
